// extracted by mini-css-extract-plugin
export default {"card":"NotReleased_card__0tCbA","icon":"NotReleased_icon__ZjDIE","text":"NotReleased_text__oLPhO"};